
import academyHeaderSearchComponent from './header-academy-search';

try {
    academyHeaderSearchComponent();
} catch (e) {
    console.log('academyHeaderSearchComponent error', e);
}

// menu brackets for "Academy menu"
const styleAcademyHeader = function() {
    const firstLevelItems = document.querySelectorAll('#main-navigation > ul > li');
    if (!firstLevelItems.length) {
        return;
    }

    firstLevelItems.forEach(function (item) {
        if (item.nextElementSibling && item.nextElementSibling.classList.contains('menu-start-bracket')) {
            item.classList.add('before-menu-with-brackets');
        }
    });
};

styleAcademyHeader();
